/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPushNotification } from '../fn/push-notification/create-push-notification';
import { CreatePushNotification$Params } from '../fn/push-notification/create-push-notification';
import { deletePushNotification } from '../fn/push-notification/delete-push-notification';
import { DeletePushNotification$Params } from '../fn/push-notification/delete-push-notification';
import { exportPushNotification } from '../fn/push-notification/export-push-notification';
import { ExportPushNotification$Params } from '../fn/push-notification/export-push-notification';
import { getPushNotification } from '../fn/push-notification/get-push-notification';
import { GetPushNotification$Params } from '../fn/push-notification/get-push-notification';
import { getPushNotificationList$Any } from '../fn/push-notification/get-push-notification-list-any';
import { GetPushNotificationList$Any$Params } from '../fn/push-notification/get-push-notification-list-any';
import { getPushNotificationList$Json } from '../fn/push-notification/get-push-notification-list-json';
import { GetPushNotificationList$Json$Params } from '../fn/push-notification/get-push-notification-list-json';
import { getPushNotificationStatistics } from '../fn/push-notification/get-push-notification-statistics';
import { GetPushNotificationStatistics$Params } from '../fn/push-notification/get-push-notification-statistics';
import { PushNotification } from '../models/push-notification';
import { PushNotificationPagedList } from '../models/push-notification-paged-list';
import { PushNotificationStatisticsList } from '../models/push-notification-statistics-list';
import { updatePushNotification } from '../fn/push-notification/update-push-notification';
import { UpdatePushNotification$Params } from '../fn/push-notification/update-push-notification';


/**
 * All about the push notification features
 */
@Injectable({ providedIn: 'root' })
export class PushNotificationService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPushNotificationList()` */
  static readonly GetPushNotificationListPath = '/custom/notifications/search';

  /**
   * Retrieve a list of notification, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPushNotificationList$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPushNotificationList$Json$Response(params?: GetPushNotificationList$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PushNotificationPagedList>> {
    return getPushNotificationList$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of notification, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPushNotificationList$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getPushNotificationList$Json(params?: GetPushNotificationList$Json$Params, context?: HttpContext): Observable<PushNotificationPagedList> {
    return this.getPushNotificationList$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PushNotificationPagedList>): PushNotificationPagedList => r.body)
    );
  }

  /**
   * Retrieve a list of notification, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPushNotificationList$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPushNotificationList$Any$Response(params?: GetPushNotificationList$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PushNotificationPagedList>> {
    return getPushNotificationList$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of notification, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPushNotificationList$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  getPushNotificationList$Any(params?: GetPushNotificationList$Any$Params, context?: HttpContext): Observable<PushNotificationPagedList> {
    return this.getPushNotificationList$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PushNotificationPagedList>): PushNotificationPagedList => r.body)
    );
  }

  /** Path part for operation `createPushNotification()` */
  static readonly CreatePushNotificationPath = '/custom/notifications';

  /**
   * Create a push notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPushNotification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPushNotification$Response(params: CreatePushNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createPushNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a push notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPushNotification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPushNotification(params: CreatePushNotification$Params, context?: HttpContext): Observable<void> {
    return this.createPushNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPushNotification()` */
  static readonly GetPushNotificationPath = '/custom/notifications/{uid}';

  /**
   * Get a push notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPushNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPushNotification$Response(params: GetPushNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<PushNotification>> {
    return getPushNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a push notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPushNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPushNotification(params: GetPushNotification$Params, context?: HttpContext): Observable<PushNotification> {
    return this.getPushNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<PushNotification>): PushNotification => r.body)
    );
  }

  /** Path part for operation `updatePushNotification()` */
  static readonly UpdatePushNotificationPath = '/custom/notifications/{uid}';

  /**
   * Update a Push Notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePushNotification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePushNotification$Response(params: UpdatePushNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updatePushNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a Push Notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePushNotification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePushNotification(params: UpdatePushNotification$Params, context?: HttpContext): Observable<void> {
    return this.updatePushNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deletePushNotification()` */
  static readonly DeletePushNotificationPath = '/custom/notifications/{uid}';

  /**
   * Delete a Push Notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePushNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePushNotification$Response(params: DeletePushNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePushNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a Push Notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePushNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePushNotification(params: DeletePushNotification$Params, context?: HttpContext): Observable<void> {
    return this.deletePushNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPushNotificationStatistics()` */
  static readonly GetPushNotificationStatisticsPath = '/custom/notifications/{uid}/statistics';

  /**
   * Get a push notification statistics.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPushNotificationStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPushNotificationStatistics$Response(params: GetPushNotificationStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<PushNotificationStatisticsList>> {
    return getPushNotificationStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a push notification statistics.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPushNotificationStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPushNotificationStatistics(params: GetPushNotificationStatistics$Params, context?: HttpContext): Observable<PushNotificationStatisticsList> {
    return this.getPushNotificationStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<PushNotificationStatisticsList>): PushNotificationStatisticsList => r.body)
    );
  }

  /** Path part for operation `exportPushNotification()` */
  static readonly ExportPushNotificationPath = '/custom/notifications/export';

  /**
   * Export the Push Notifications.
   *
   * Allows to export the Push Notification.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportPushNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPushNotification$Response(params?: ExportPushNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportPushNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the Push Notifications.
   *
   * Allows to export the Push Notification.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportPushNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportPushNotification(params?: ExportPushNotification$Params, context?: HttpContext): Observable<Blob> {
    return this.exportPushNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
